export default "__VITE_ASSET__CLunIccd__"